<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="卡密状态：" prop="activeStatus">
            <el-select v-model="searchForm.activeStatus" placeholder="请选择" class="mt-search-width">
              <el-option
                v-for="item in activeStatusList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用状态：" prop="useStatus">
            <el-select v-model="searchForm.useStatus" placeholder="请选择" class="mt-search-width">
              <el-option
                v-for="item in useStatusList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="记录搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入卡号/用户昵称/手机号搜索"></el-input>
          </el-form-item>
          <el-form-item label="时间筛选：" prop="name">
            <el-date-picker
              v-model="searchForm.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="cardNo"
            label="卡号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cardPassword"
            label="卡密">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cardName"
            label="礼品卡名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="faceValuePrice"
            label="面额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="activeStatus"
            label="卡密状态">
            <template slot-scope="scope">
              <span v-if="scope.row.activeStatus == 0">未激活</span>
              <span v-else-if="scope.row.activeStatus == 1" class="color-theme">已激活</span>
              <span v-else>已作废</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="useStatus"
            label="使用状态">
            <template slot-scope="scope">
              <span v-if="scope.row.useStatus == 1" class="color-theme">已使用</span>
              <span v-else>未使用</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="useNickName"
            label="充值用户昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="usePhone"
            label="充值账户">
          </el-table-column>
          <el-table-column
            align="center"
            prop="orderNo"
            label="关联订单">
          </el-table-column>
          <el-table-column
            align="center"
            prop="activeDateTime"
            label="激活时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cancelDateTime"
            label="作废时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="useDateTime"
            label="使用时间">
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryGiftCardOrderMinePageList } from '@/api/giftCard'
export default {
  name: 'CardEncryptionRecord',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:'',
        useStatus:'',
        activeStatus:'',
        date: ['', '']
      },
      useStatusList:[{
        id:0,
        name:'未使用'
      },{
        id:1,
        name:'已使用'
      }],
      activeStatusList:[{
        id:0,
        name:'未激活'
      },{
        id:1,
        name:'已激活'
      },{
        id:2,
        name:'已作废'
      }]
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let activeStatus = that.searchForm.activeStatus
      let useStatus = that.searchForm.useStatus
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      let page = that.currentPage
      queryGiftCardOrderMinePageList({ activeStatus: activeStatus, useStatus: useStatus, webSearchStr: searchName,starteCreateDate: startDate, endCreateDate: endDate, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/giftCard/CardEncryptionRecord.vue